module.exports = __webpack_public_path__ + "static/goals_senior_developer_art@2x-0fd573d2933e94d30d712061a93eddf0.png";